import * as THREE from 'three';
import p5 from "p5";
import { Params } from '../../data/Params';
import { QTreeDispQuad } from '../../quads/QTreeDispQuad';
import { Random } from '../../data/Random';


export class QTreeRect {

    public x:number;
    public y:number;
    public w:number;
    public h:number;
    public r:number;
    public g:number;
    public b:number;
    public a:number;
    public visible:boolean;
    public depth:number=0;
    public dom:QTreeDispQuad;
    public rule:number = 0;


    constructor(xx:number,yy:number,ww:number,hh:number,depth:number){

        this.x = xx;
        this.y = yy;
        this.w = ww;
        this.h = hh;
        this.visible=false;

        this.a=1;
        this.depth=depth;

    }


    public reset(){

       

    }



    public show(){

        if(this.visible)return;

        this.visible=true;
        this.r = 255;
        this.b = 0;
        this.dom.show();

    }

    public hide():void{
        this.visible=false;
    }

    public setRule(ruleIndex:number){
        
        this.rule = ruleIndex;
        this.g = ruleIndex;

    }

    public changeRule(){
        this.rule+=1;
        this.rule=this.rule%256;
        this.setRule(
            this.rule
        )
    }

    public update(p:p5){

        if(!this.visible) return;
        
        //console.log("updae")
        this.r=this.r-15;
        if(this.r<0){
            this.r=0;
            //this.dom.hide();
        }

        p.fill(
            this.r,this.g,this.b,255
        );
        
        p.rect(
            this.x,this.y,this.w,this.h
        );

    }

}